import { RefObject } from 'react'
import { connect } from 'react-redux'

import SSRInterface from '../../interfaces/client/SSR'
import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import SelectOptionInterface from '../../interfaces/client/SelectOption'

import { getLuggageSSRs, getLuggageCodeLabel } from '../../utils/ssrs'

import SelectField from '../../components/SelectField'

interface LuggageSelectFormRowPropsInterface {
  passengerId: string
  refName: string
  elementRef: RefObject<HTMLSelectElement>
  isDisabled: boolean
  readonly?: string
}

const getAmountFromLuggageId = (luggageId: string) =>
  Number(luggageId.replace('5B', ''))

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: LuggageSelectFormRowPropsInterface
) => {
  // Get luggage SSRs
  const allSSRs: SSRInterface[] = state.ssrs.allIds.map(
    (ssrId: string) => state.ssrs.byId[ssrId]
  )
  const luggageSSRs: SSRInterface[] = getLuggageSSRs(allSSRs)

  // Get passenger Luggage data
  const passenger = state.passengers.byId[props.passengerId]
  const defaultLuggageCode =
    passenger && passenger.luggage ? passenger.luggage || '' : ''
  const currentPassengerLuggageValue = defaultLuggageCode
    ? getAmountFromLuggageId(defaultLuggageCode)
    : 0

  // Create luggage options
  const luggageOptions: SelectOptionInterface[] = luggageSSRs.map(
    (luggageSSR: SSRInterface) => {
      const luggageValue = getAmountFromLuggageId(luggageSSR.id)

      return {
        label: getLuggageCodeLabel(luggageSSR.id),
        value: luggageSSR.id,
        disabled: luggageValue < currentPassengerLuggageValue || luggageSSR.availableCount === 0,
      }
    }
  )

  // Add no luggage option
  const noLuggageOption = {
    label: '-',
    value: '',
    disabled: Boolean(currentPassengerLuggageValue),
  }

  const luggageOptionsIncludingNoLuggage: SelectOptionInterface[] = [
    noLuggageOption,
    ...luggageOptions,
  ]

  return {
    defaultValue: defaultLuggageCode,
    options: luggageOptionsIncludingNoLuggage,
    isRequired: false,
    inputName: `${props.passengerId}-luggage`,
    elementRef: props.elementRef,
    readonly: props.readonly,
    isDisabled: props.isDisabled,
    refName: props.refName,
  }
}

export default connect(mapStateToProps)(SelectField)
